module.exports = __webpack_public_path__ + "img/vvip-new-menu-tasting.0248d80d.webp";